import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { CaretDown } from '@phosphor-icons/react';
import { DOCS_CATEGORIES } from '@/pages/docs/docsData';

export default function DocsSidebar({ onNavigate }) {
  const { category: activeCategory, slug: activeSlug } = useParams();
  const [expanded, setExpanded] = useState(() => {
    const initial = {};
    DOCS_CATEGORIES.forEach(cat => {
      initial[cat.id] = cat.id === activeCategory || cat.id === 'getting-started';
    });
    return initial;
  });

  const toggle = (id) => {
    setExpanded(prev => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <nav aria-label="Documentation navigation" className="space-y-0.5" data-testid="docs-sidebar">
      {DOCS_CATEGORIES.map(cat => {
        const Icon = cat.icon;
        const isExpanded = expanded[cat.id];
        const isCategoryActive = cat.id === activeCategory;

        return (
          <div key={cat.id}>
            <button
              onClick={() => toggle(cat.id)}
              className={`w-full flex items-center gap-2.5 px-2.5 py-2 text-left rounded-lg transition-colors ${isCategoryActive ? 'text-foreground' : 'text-muted-foreground hover:text-foreground hover:bg-secondary/40'}`}
              data-testid={`docs-cat-${cat.id}`}
            >
              <Icon size={14} weight="bold" style={{ color: cat.color }} className="flex-shrink-0" />
              <span className="text-[12.5px] font-semibold flex-1 truncate">{cat.title}</span>
              <CaretDown
                size={11}
                weight="bold"
                className={`flex-shrink-0 text-muted-foreground/60 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}
              />
            </button>
            {isExpanded && (
              <div className="ml-[1.15rem] pl-3.5 border-l border-border space-y-0.5 mt-0.5 mb-3">
                {cat.articles.map(article => {
                  const isActive = isCategoryActive && article.slug === activeSlug;
                  return (
                    <Link
                      key={article.slug}
                      to={`/docs/${cat.id}/${article.slug}`}
                      onClick={onNavigate}
                      className={`block px-2.5 py-1.5 text-[12px] rounded-lg transition-colors leading-snug ${isActive ? 'font-semibold text-foreground bg-secondary' : 'text-muted-foreground hover:text-foreground hover:bg-secondary/40'}`}
                      style={isActive ? { borderLeft: `2px solid ${cat.color}`, marginLeft: '-15px', paddingLeft: '21px' } : {}}
                      data-testid={`docs-link-${cat.id}-${article.slug}`}
                    >
                      {article.title}
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </nav>
  );
}
